import {  ClientsTab } from "../components/organisms";
import { useClientsUrlQuery } from "../api/client/clients.queries";
import { LoadingBlurDiv } from "@shared/components";

const ClientsPage = () => {
  const { query, setFilters, resetFilters, currentFilters } =
    useClientsUrlQuery();

  return (
    <LoadingBlurDiv isLoading={query.isFetching}>
      <ClientsTab
        clients={query.data?.data || []}
        paginatedMeta={query.data?.meta}
        onFilter={setFilters}
        onClearFilter={resetFilters}
        initialFilters={currentFilters}
      />
    </LoadingBlurDiv>
  );
};

export default ClientsPage;
